import { SvgIcon, SvgIconProps } from '@mui/material';

export function LaptopMagnifyingGlassIllustration(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 176 176'
    >
      <g filter='url(#filter0_i_13570_19686)'>
        <rect
          width='176'
          height='176'
          rx='88'
          fill='#F0F5FF'
        />
        <g filter='url(#filter1_d_13570_19686)'>
          <path
            d='M38.1641 57.9839C38.1641 53.5656 41.7458 49.9839 46.1641 49.9839H128.418C132.836 49.9839 136.418 53.5656 136.418 57.9839V112.2H38.1641V57.9839Z'
            fill='#2D6FD7'
          />
        </g>
        <rect
          x='44.1035'
          y='56.2637'
          width='86.7142'
          height='50.6766'
          rx='3.5'
          fill='white'
          stroke='#DFEAFB'
        />
        <g filter='url(#filter2_d_13570_19686)'>
          <path
            d='M32.3838 112.709H141.857V114.769C141.857 119.187 138.275 122.769 133.857 122.769H40.3838C35.9655 122.769 32.3838 119.187 32.3838 114.769V112.709Z'
            fill='#2D6FD7'
          />
        </g>
        <circle
          cx='87.1203'
          cy='117.64'
          r='3.0598'
          fill='#3E8FFA'
        />
        <g filter='url(#filter3_d_13570_19686)'>
          <path
            d='M128.618 92.7704C127.747 102.627 118.982 109.905 109.04 109.026C99.0986 108.148 91.7454 99.4454 92.6163 89.5891C93.4873 79.7328 102.253 72.4548 112.194 73.3333C122.136 74.2118 129.489 82.9141 128.618 92.7704Z'
            fill='#3E8FFA'
          />
        </g>
        <g filter='url(#filter4_d_13570_19686)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M109.35 105.52C117.384 106.23 124.414 100.352 125.112 92.4606C125.809 84.5692 119.918 77.5496 111.884 76.8397C103.851 76.1298 96.82 82.0076 96.1227 89.899C95.4254 97.7904 101.316 104.81 109.35 105.52ZM109.04 109.026C118.982 109.905 127.747 102.627 128.618 92.7704C129.489 82.9141 122.136 74.2118 112.194 73.3333C102.253 72.4548 93.4873 79.7328 92.6163 89.5891C91.7454 99.4454 99.0986 108.148 109.04 109.026Z'
            fill='#3E8FFA'
          />
        </g>
        <circle
          cx='110.472'
          cy='91.1768'
          r='11.4185'
          transform='rotate(5.04987 110.472 91.1768)'
          fill='#F0F5FF'
          stroke='#F0F5FF'
          strokeWidth='6'
        />
        <g filter='url(#filter5_d_13570_19686)'>
          <rect
            width='9.51993'
            height='5.98381'
            transform='matrix(0.793739 0.608258 -0.614451 0.788955 126.306 99.4058)'
            fill='#3E8FFA'
          />
        </g>
        <g filter='url(#filter6_d_13570_19686)'>
          <rect
            width='21.537'
            height='6.89136'
            rx='3.44568'
            transform='matrix(0.793739 0.608258 -0.614451 0.788955 132.521 103.5)'
            fill='#1F477D'
          />
          <rect
            x='0.308885'
            y='2.40718'
            width='18.0913'
            height='3.44568'
            rx='1.72284'
            transform='matrix(0.793739 0.608258 -0.614451 0.788955 134.064 103.82)'
            stroke='#1F477D'
            strokeWidth='3.44568'
          />
        </g>
        <rect
          width='3.04011'
          height='8.46187'
          rx='1.52006'
          transform='matrix(0.811987 0.583676 -0.589821 0.807534 133.875 103.489)'
          fill='#1F477D'
        />
        <path
          d='M132.899 104.855L129.767 109.097L128.698 107.449L131.101 104.031L132.899 104.855Z'
          fill='#3E8FFA'
        />
      </g>
      <defs>
        <filter
          id='filter0_i_13570_19686'
          x='0'
          y='0'
          width='185'
          height='196'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='BackgroundImageFix'
            result='shape'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='9'
            dy='25'
          />
          <feGaussianBlur stdDeviation='10' />
          <feComposite
            in2='hardAlpha'
            operator='arithmetic'
            k2='-1'
            k3='1'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.7275 0 0 0 0 0.810305 0 0 0 0 0.97 0 0 0 0.6 0'
          />
          <feBlend
            mode='normal'
            in2='shape'
            result='effect1_innerShadow_13570_19686'
          />
        </filter>
        <filter
          id='filter1_d_13570_19686'
          x='36.1641'
          y='49.9839'
          width='112.254'
          height='79.2158'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='5'
            dy='10'
          />
          <feGaussianBlur stdDeviation='3.5' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.176471 0 0 0 0 0.435294 0 0 0 0 0.843137 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_13570_19686'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_13570_19686'
            result='shape'
          />
        </filter>
        <filter
          id='filter2_d_13570_19686'
          x='30.3838'
          y='112.709'
          width='123.473'
          height='27.0596'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='5'
            dy='10'
          />
          <feGaussianBlur stdDeviation='3.5' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.176471 0 0 0 0 0.435294 0 0 0 0 0.843137 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_13570_19686'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_13570_19686'
            result='shape'
          />
        </filter>
        <filter
          id='filter3_d_13570_19686'
          x='90.5459'
          y='73.2615'
          width='50.1426'
          height='52.8367'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='5'
            dy='10'
          />
          <feGaussianBlur stdDeviation='3.5' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.176471 0 0 0 0 0.435294 0 0 0 0 0.843137 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_13570_19686'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_13570_19686'
            result='shape'
          />
        </filter>
        <filter
          id='filter4_d_13570_19686'
          x='90.5459'
          y='73.2615'
          width='50.1426'
          height='52.8367'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='5'
            dy='10'
          />
          <feGaussianBlur stdDeviation='3.5' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.176471 0 0 0 0 0.435294 0 0 0 0 0.843137 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_13570_19686'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_13570_19686'
            result='shape'
          />
        </filter>
        <filter
          id='filter5_d_13570_19686'
          x='120.629'
          y='99.4058'
          width='25.2334'
          height='27.5115'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='5'
            dy='10'
          />
          <feGaussianBlur stdDeviation='3.5' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.176471 0 0 0 0 0.435294 0 0 0 0 0.843137 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_13570_19686'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_13570_19686'
            result='shape'
          />
        </filter>
        <filter
          id='filter6_d_13570_19686'
          x='127.681'
          y='104.882'
          width='32.542'
          height='32.7739'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='5'
            dy='10'
          />
          <feGaussianBlur stdDeviation='3.5' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.176471 0 0 0 0 0.435294 0 0 0 0 0.843137 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_13570_19686'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_13570_19686'
            result='shape'
          />
        </filter>
      </defs>
    </SvgIcon>
  );
}
